import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const MapPin: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.93404 2.26744L3.80004 2.40144C2.34238 3.8591 2.17623 6.16597 3.40994 7.81748L6.59146 11.9627C6.79405 12.2267 7.19225 12.2256 7.39331 11.9604L10.5437 7.80608C11.7838 6.1483 11.6176 3.83128 10.1537 2.36739L10.0538 2.26744C8.36385 0.577521 5.62396 0.577522 3.93404 2.26744Z"
        stroke="currentColor"
        strokeWidth="0.9"
      />
      <path
        d="M6.96709 7.02403C7.89546 7.02403 8.64805 6.27144 8.64805 5.34307C8.64805 4.4147 7.89546 3.66211 6.96709 3.66211C6.03872 3.66211 5.28613 4.4147 5.28613 5.34307C5.28613 6.27144 6.03872 7.02403 6.96709 7.02403Z"
        stroke="currentColor"
        strokeWidth="0.9"
      />
      <path
        d="M3.1012 10.9307C1.8155 11.2502 1 11.7262 1 12.2577C1 13.2198 3.6717 13.9998 6.96741 13.9998C10.2631 13.9998 12.9348 13.2198 12.9348 12.2577C12.9348 11.7262 12.1193 11.2502 10.8336 10.9307"
        stroke="currentColor"
        strokeWidth="0.9"
        strokeLinecap="round"
      />
    </svg>
  )
})

MapPin.displayName = 'MapPin'
